import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Cursor1.css'
import image1 from '../images/Boutique1.jpg';
import image2 from '../images/Boutique2.jpg';
import image3 from '../images/Boutique3.jpg';
import {Link} from 'react-router-dom'
import { v4 as uuidv4 } from "uuid";


const images = [
  {
    id: uuidv4(),
    pg: image1,
    textOne: 'مرحبا',
    textTwo: 'كل يوم',
  },
  {
    id: uuidv4(),
    pg: image2,
    textOne: 'Bienvenue',
    textTwo: 'tous les jours',
  },
  {
    id: uuidv4(),
    pg: image3,
    textOne: 'bienvenidos',
    textTwo: 'todos los días',
  },
];



const Cursor1 = () => {
  return (
    <Carousel fade={true} pause={false}>
      {images.map(image => (
        <Carousel.Item interval={2000} className='titre1'>
          <img className='tsst' src={image.pg} />
          <div className='Commentaire'>
              <h1 className='trt'>Soyez les bienvenue dans notre boutique 
                  <br />
                  <span className='W'>W</span><span className='elcome'>elcome</span>
                  <br />
                  <Link to='/produits'>
                    <button type='button' className='BottonVoir'>
                      <h4>   
                          Voir Plus
                      </h4>
                    </button>
                  </Link> 
              </h1>
          </div>
          <Carousel.Caption className='tsst1'>
            <h3>{image.textOne}</h3>
            <p>{image.textTwo}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default Cursor1;